import React, { useEffect, useState } from 'react';

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem('selected-theme');
    return stored ? stored === 'dark' : false;
  });

  useEffect(() => {
    document.body.classList.toggle('dark-theme', dark);
    localStorage.setItem('selected-theme', dark ? 'dark' : 'light');
  }, [dark]);

  // shadow header on scroll
  useEffect(() => {
    const handleShadow = () => {
      const header = document.getElementById('header');
      if (!header) return;
      window.scrollY >= 50 ? header.classList.add('shadow-header') : header.classList.remove('shadow-header');
    };
    window.addEventListener('scroll', handleShadow);
    return () => window.removeEventListener('scroll', handleShadow);
  }, []);

  // active-link on scroll (keeps behaviour similar to original)
  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    const scrollActive = () => {
      const scrollY = window.scrollY;
      sections.forEach(current => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 58;
        const sectionId = current.getAttribute('id');
        const sectionsClass = document.querySelector('.nav__menu a[href*=' + sectionId + ']');
        if (sectionsClass) {
          if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionsClass.classList.add('active-link');
          } else {
            sectionsClass.classList.remove('active-link');
          }
        }
      });
    };
    window.addEventListener('scroll', scrollActive);
    return () => window.removeEventListener('scroll', scrollActive);
  }, []);

  // When clicking nav links, close mobile menu
  useEffect(() => {
    const links = document.querySelectorAll('.nav__link');
    const linkAction = () => {
      setShowMenu(false);
    };
    links.forEach(n => n.addEventListener('click', linkAction));
    return () => links.forEach(n => n.removeEventListener('click', linkAction));
  }, []);

  return (
    <header className="header" id="header">
      <nav className="nav container">
        <a href="#" className="nav__logo">
          <span className="nav__logo-circle">
            <img src="../../assets/trakiologoremove.jpeg"alt="logoimage" className="nav__logo-circle" />
          </span>
          <span className="nav__logo-name">Traki. </span>
        </a>

        <div className={`nav__menu ${showMenu ? 'show-menu' : ''}`} id="nav-menu">
          <span className="nav__title">Menu</span>

          <h3 className="nav__name">Traki</h3>

          <ul className="nav__list">
            <li className="nav__item">
              <a href="#home" className="nav__link active-link">Home</a>
            </li>

            <li className="nav__item">
              <a href="#about" className="nav__link">LoRe</a>
            </li>

            <li className="nav__item">
              <a href="#projects" className="nav__link">Features</a>
            </li>

            <li className="nav__item">
              <a href="#contact" className="nav__link nav__link-button">Contact Me</a>
            </li>
          </ul>

          <div className="nav__close" id="nav-close" onClick={() => setShowMenu(false)}>
            <i className="ri-close-line"></i>
          </div>
        </div>

        <div className="nav__buttons">
          <i
            className={`ri-moon-line change-theme ${dark ? 'ri-sun-line' : ''}`}
            id="theme-button"
            onClick={() => setDark(d => !d)}
            style={{ cursor: 'pointer' }}
            title="Toggle theme"
          ></i>

          <div className="nav__toggle" id="nav-toggle" onClick={() => setShowMenu(s => !s)}>
            <i className="ri-menu-4-line"></i>
          </div>
        </div>
      </nav>
    </header>
  );
}
